export type TravelMethod = "subway" | "taxi";

export interface TravelMethodDef {
  id: TravelMethod;
  label: string;
  staminaCost: number;
  goldCost: number;
}

export const TRAVEL_METHODS: Record<TravelMethod, TravelMethodDef> = {
  subway: { id: "subway", label: "🚇 지하철", staminaCost: 5, goldCost: 0 },
  taxi:   { id: "taxi",   label: "🚕 택시",   staminaCost: 0, goldCost: 50 },
};
